define('TescoMobile_ClubCard/js/view/pdp-summary',['uiComponent', 'ko', 'jquery', 'mage/translate', 'Magento_Catalog/js/price-utils', 'TescoMobile_Catalog/js/model/deal', 'TescoMobile_ClubCard/js/view/savings', 'priceBox'], function (Component, ko, $, $t, priceUtils, deal, savings) {
  'use strict';

  return Component.extend({
    defaults: {
      deviceMonthlyPrice: 0,
      monthlyTotal: 0,
      deviceFullPrice: 0,
      contractType: null,
      tariffData: null,
      isFrozenPricingEnabled: false,
      priceRiseCopy: '',
      isPriceRiseEnabled: false,
      isScdProduct: false,
      imports: {
        clubCardPrice: "tm-clubcard-price-provider:clubCardPrice",
        deviceClubCardPrice: "tm-clubcard-price-provider:deviceClubCardPrice",
        pufClubCardPrice: "tm-clubcard-price-provider:pufClubCardPrice",
        tariffData: "tm-deal-tariff:selectedTariff",
        selectedPuf: "tm-cca-price:selectedPuf",
        deviceMonthlyPrice: "tm-cca-price:deviceMonthlyPrice",
        deviceFullPrice: "tm-cca-price:deviceFullPrice",
        selectedTenure: "tm-cca-price:selectedTenure",
        contractType: "contract_type_switcher:contractType"
      }
    },
    initObservable: function () {
      this._super().observe(['deviceMonthlyPrice', 'deviceFullPrice', 'tariffData', 'monthlyTotal', 'clubCardPrice', 'deviceClubCardPrice', 'contractType', 'pufClubCardPrice', 'selectedPuf', 'selectedTenure']);
      return this;
    },
    initialize: function () {
      const self = this;
      this._super();
      this.isAui = ko.computed(function () {
        return self.selectedPuf() === 'all';
      });
      this.getTenure = ko.computed(function () {
        return self.selectedTenure() > 0 ? self.selectedTenure() + ' ' + $t('months') : false;
      });
      this.getPuf = ko.computed(function () {
        const puf = self.isAui() ? self.deviceFullPrice() : self.selectedPuf();
        const pufLabel = self.isAui() ? $t('Full price') : $t('upfront');
        return `${self.getFormattedPrice(puf)} ${pufLabel}`;
      });
      $(document).on('DynamicOptionsPriceUpdateAfter', $.proxy(this._updateMonthlyTotal, this));
      $(document).on('DynamicOptionsPriceUpdateAfter', $.proxy(this.updateSavings, this));
    },
    isPayM: function () {
      return this.contractType() === 'paym';
    },
    getFormattedPrice(price) {
      return priceUtils.formatPrice(price);
    },
    _updateMonthlyTotal: function (event, data) {
      this.monthlyTotal(data);
    },
    getPriceRiseCopy: function () {
      return this.priceRiseCopy;
    },
    updateSavings: function () {
      var _this$tariffData;
      if (!this.isFrozenPricingEnabled || !((_this$tariffData = this.tariffData()) !== null && _this$tariffData !== void 0 && _this$tariffData.hasOwnProperty('clubcard_price'))) {
        return `You'll save <strong>${savings().calculatedSavings()}</strong> over your contract thanks to Clubcard Prices.`;
      }
      let contractLength = !this.isAui() ? this.selectedTenure() + ` months` : `your contract`;
      return `Clubcard Prices – Frozen for your contract <br>You'll save <strong>${savings().calculatedSavings()}</strong> over ${contractLength}.`;
    },
    isBau: function () {
      return !this.isAui() && this.deviceMonthlyPrice() == 0;
    }
  });
});

